/* eslint-disable sort-keys */
import { FC, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTheme } from 'styled-components';
import { v4 } from 'uuid';

import { Service } from '../../../store/_declarations/target';
import { useAppSelector } from '../../../store/hooks';
import Font from '../../atoms/Font';
import Icon from '../../atoms/Icon';
import ServiceListItem from '../../molecules/ServicesListItem';
import {
  ServicesListSection,
  ServicesListWrapper,
  ServiceWrapperLi,
  TitleWrapper,
  TooltipContent
} from './styles';

export type ServiceListProps = {
  onChangeCategory?: (rootService: Service, optionService: Service) => void;
  servicesList: Service[];
};
const ServiceList: FC<ServiceListProps> = memo(
  ({ onChangeCategory, servicesList }) => {
    const { widgetType } = useAppSelector((state) => state.app);
    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };
    const { t } = useTranslation();
    const theme = useTheme();

    return (
      <>
        {servicesList.length > 0 && (
          <ServicesListSection>
            <Font
              variant={widgetType === 'modal' ? 'bodyBold' : 'bodyLBold'}
            >{`${t('IncludedServices')}`}</Font>
            <ServicesListWrapper>
              {(isOpen || widgetType !== 'modal'
                ? servicesList
                : servicesList.slice(0, 6)
              ).map((service) => (
                <ServiceWrapperLi key={`ServicesList_${v4()}`}>
                  <ServiceListItem
                    onChangeCategory={onChangeCategory}
                    service={service}
                  />
                </ServiceWrapperLi>
              ))}
            </ServicesListWrapper>
          </ServicesListSection>
        )}
        {widgetType === 'modal' && servicesList.length > 6 && (
          <TitleWrapper data-testid="show-more-button" onClick={toggleDropdown}>
            <Font variant="bodyBold">{`${t(isOpen ? 'ShowLess' : 'ShowMore')}`}</Font>

            <Icon
              iconColor={widgetType === 'modal' ? 'black' : 'brand2'}
              iconName={isOpen ? 'InterfaceChevronUp' : 'InterfaceChevronDown'}
            />
          </TitleWrapper>
        )}
        {widgetType === 'modal' && (
          <ReactTooltip
            id="serviceItemTooltip"
            opacity={1}
            render={({ content }) => (
              <TooltipContent>
                <Font
                  customConfiguration={{ color: 'white' }}
                  dangerouslySetInnerHTML={{ __html: content || '' }}
                  variant="bodySRegular"
                />
              </TooltipContent>
            )}
            style={{ backgroundColor: theme.colors.neutral400 }}
          />
        )}
      </>
    );
  }
);

export default ServiceList;
